// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3Ra01","itemTitle":"ClientEmergencyInfo_itemTitle__38eAL","itemText":"ClientEmergencyInfo_itemText__2vCe3"};